/* ================================================== */
/* FLICKITY > Init > controls
/* ================================================== */

function flickityControls($carousel) {
	var $controls = $('.controls', $carousel),
		dataClass = '.data';

	$controls.on('click', function() {

		if ($controls.attr('data-mode') == 'isPlaying') {

			$controls.attr('data-mode', 'isPaused');
			$(dataClass, $controls).html($(dataClass, $controls).data('play'));
			$carousel.flickity('stopPlayer');

		} else if ($controls.attr('data-mode') == 'isPaused') {

			$controls.attr('data-mode', 'isPlaying');
			$(dataClass, $controls).html($(dataClass, $controls).data('pause'));
			$carousel.flickity('playPlayer');

		}

	});
}